(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spa-concept"] && !Shopify.designMode) return;
  try {
    
	$(document).ready(function(){
		console.log( "SPA CONCEPT: ready" );

		$('.sns-image-slider').each(function(idx) {
			var sliderDiv = $(this);
			var sectionId = sliderDiv.data('section-id');
			var sliderId = "#sns_slider_" + sectionId;
			var thumbsId = "#sns_thumbs_" + sectionId;
			
			// 画像が存在するかチェック
			if ($(sliderId + " li").length === 0) {
				console.warn("No images found in slider for section:", sectionId);
				return;
			}
			
			$(sliderId).slick({
				dots: false,
				focusOnSelect: true,
				pauseOnHover:false,
				infinite: true,
				speed: 500,
				fade: true,
				autoplay: true,
				cssEase: 'linear'
			});
			$(thumbsId).slick({
				dots: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				focusOnSelect: true,
				pauseOnHover:false,
				infinite: false,
				speed: 500,
				fade: false,
				autoplay: false,
				arrows: false,
				cssEase: 'linear',
				asNavFor: sliderId
			});

			$(sliderId).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// console.log( "SLICK_BEFORE_CHANGE: [ " + currentSlide + " : " + nextSlide + " ]" );
				//
				// $(thumbsId).slick( 'slickGoTo', currentSlide, false );
				// SLICK unfortunately provides no means of "mark as current" other than the
				// method "slickGoTo". Sadly, this method will scroll the thumbnails to make
				// the "current" slide be first in view. Not what we want. So we simply work
				// with the classes directly...

				var nthSlide = nextSlide + 1;  // CSS wants base 1, but Slick is base 0
				$(thumbsId).find('.slick-track .slick-slide').removeClass('slick-current');
				$(thumbsId).find('.slick-track .slick-slide:nth-child('+nthSlide+')').addClass('slick-current');
			});
		});

		$(".js-zoom").colorbox({rel:'js-zoom'});

		$('.sns-cmt-slider').each(function(idx) {
			var cmtSlider = $(this);
			// console.log( "cmtSlider: ", cmtSlider );
			var cmtSectionId = cmtSlider.data('section-id');
			// console.log( "cmtSectionId: '" + cmtSectionId + "'" );
			var nextArrow = "#slick_next_" + cmtSectionId;
			var prevArrow = "#slick_prev_" + cmtSectionId;
			var autoplay = cmtSlider.data('autoplay') !== undefined ? cmtSlider.data('autoplay') : true;
			// console.log( "PREV '" + prevArrow + "'   NEXT '" + nextArrow + "'" );
			cmtSlider.slick({
				dots: true,
				focusOnSelect: true,
				pauseOnHover:false,
				infinite: true,
				speed: 500,
				fade: true,
				autoplay: autoplay, // 設定値を反映
				cssEase: 'linear',
				arrows: true,
				adaptiveHeight: true,
				nextArrow: $(nextArrow),
				prevArrow: $(prevArrow)
			});
		});

		$('.sns-product__form').on('submit', function(ev) {
			var form = $(this);
			var sectionId = form.find('.sns-block__variation-box').data('section-id');
			var variantId = form.find('#variant_id_' + sectionId).val();
		});

		$('.sns-block__variation-box .spa-swatch-input').on('change', function(ev) {
			var swatchInput = $(this);
			var variationName = swatchInput.val();
			var varNameLower = variationName.toLowerCase();
			var optionBox = swatchInput.parents('.sns-block__variation-box');
			var sectionId = optionBox.data('section-id');
			var variationId = swatchInput.data('variation-id');

			var infoLabel = optionBox.find('.variant-picker__option-info variant-option-value');
			var variantInput = $('#variant_id_' + sectionId);
			variantInput.val(variationId);
			infoLabel.text(variationName);

			if ( Array.isArray(gOCSpaConceptVariations) && typeof(gOCSpaConceptVariations[sectionId]) == 'object' )
			{
				var sectionData = gOCSpaConceptVariations[sectionId];
				
				if ( typeof(sectionData[varNameLower]) == 'object' )
				{
					var variationData = sectionData[varNameLower];
					
					if ( Array.isArray(variationData.images) )
					{
						var sliderId = "#sns_slider_" + sectionId;
						var thumbsId = "#sns_thumbs_" + sectionId;
						var slider = $(sliderId);
						var thumbs = $(thumbsId);

						slider.slick( 'slickRemove', null, null, true );
						slider.slick( 'unslick' );

						thumbs.slick( 'slickRemove', null, null, true );
						thumbs.slick( 'unslick' );

						variationData.images.forEach(function(val, idx, arr) {
							var svgHtml = '<svg role="presentation" fill="none" stroke-width="2" focusable="false" width="15" height="15" class="icon icon-image-zoom" viewBox="0 0 15 15">';
							svgHtml += '<circle cx="7.067" cy="7.067" r="6.067" stroke="currentColor"></circle>';
							svgHtml += '<path d="M11.4 11.4 14 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>';
							svgHtml += '<path d="M7 4v6M4 7h6" stroke="currentColor"></path>';
							svgHtml += '</svg>';

							var slideHtml = '<li class="js-sns-block__item variant-image" data-variant-id="' + variationData.id + '">';
							slideHtml += '<img src="' + val + '" alt="Slide #' + idx + '" width="800" height="600">';
							slideHtml += '<a href="' + val + '" class="js-zoom">';
							slideHtml += svgHtml;
							slideHtml += '</a>';
							slideHtml += '</li>';

							// console.log( "SlideHTML: ", slideHtml );
							slider.append( slideHtml );

							var thumbHtml = '<li class="sns-block__item thumbnail variant-thumbnail" data-variant-id="' + variationData.id + '">';
							thumbHtml += '<img src="' + val + '" alt="Thumb #' + idx + '" width="200" height="150">';
							thumbHtml += '</li>';
							thumbs.append( thumbHtml );
						});

						slider.slick({
							dots: false,
							focusOnSelect: true,
							pauseOnHover:false,
							infinite: true,
							speed: 500,
							fade: true,
							autoplay: true,
							cssEase: 'linear'
						});

						thumbs.slick({
							dots: false,
							slidesToShow: 4,
							slidesToScroll: 1,
							focusOnSelect: true,
							pauseOnHover:false,
							infinite: false,
							speed: 500,
							fade: false,
							autoplay: false,
							arrows: false,
							cssEase: 'linear',
							asNavFor: sliderId
						});
					} else {
						console.log( "ERROR Variation[" + varNameLower + "] has no images.")
					}
				} else {
					console.log( "ERROR No specific variation data for name '" + varNameLower + "'." )
				}
			} else {
				console.log( "ERROR No variations vata for section '" + sectionId + "'" );
			}
		});

		$('.sns-block__ct-accordion .sns-accordion-control').on('click', function(ev) {
			var accordCtl = $(this);
			var accordItem = accordCtl.parent();
			accordItem.toggleClass('open');
		});

		$('.sns-block__ct-btm .spa-color-picker label').on('click', function(ev) {
			// console.log( "LABEL CLICKED" );
			var label = $(this);
			var labelFor = label.attr('for');
			var colorInput = $('#'+labelFor);
			if ( colorInput.length ) {
				var variantId = colorInput.data('variation-id');
				var section = label.parents('.shopify-section--spa-styler-concept');
				if ( section.length ) {
					var slides = section.find('.sns-slider-slides');
					var thumbs = section.find('.sns-slider-thumbs');
					if ( slides.length && thumbs.length ) {
						var slide = slides.find('li[data-variant-id="' + variantId + '"]' );
						if ( slide.length  ) {
							var slideIndex = slide.data('slick-index')
							// console.log( "   SLICK INDEX: ", slideIndex );
							slides.slick('slickGoTo', slideIndex);
							slides.slick('slickPause');
						}
					}
				}
			}
		});

		function spa_concept_check_adjust_sections()
		{
			// console.log( "   spa_concept_check_adjust_sections()" );
			$('.shopify-section--spa-styler-concept').each(function(idx) {
				var conceptSection = $(this);
				var winWidth = $(window).width();
				var ctDiv = conceptSection.find('.sns-block__ct');
				var slDiv = conceptSection.find('.sns-block__sl');
				var topDiv = ctDiv.find('.sns-block__ct-top');
				if ( winWidth > 767 ) {
					// CHANGE TO DESKTOP
					if ( conceptSection.hasClass('concept-is-mobile') ) {
						var cmtSlider = ctDiv.find('.slick-sns-comments');
						if ( cmtSlider.length ) {
							cmtSlider.detach();
							slDiv.append( cmtSlider );
						}
						conceptSection.removeClass('concept-is-mobile');
						// console.log( "CONCEPT FLIPPED TO DESKTOP..." );
					}
				} else {
					// CHANGE TO MOBILE
					if ( ! conceptSection.hasClass('concept-is-mobile') ) {
						var cmtSlider = slDiv.find('.slick-sns-comments');
						if ( cmtSlider.length ) {
							cmtSlider.detach();
							topDiv.find('div:eq(0)').after( cmtSlider );
						}
						conceptSection.addClass('concept-is-mobile');
						// console.log( "CONCEPT FLIPPED TO MOBILE" );
					}
				}
			});
		}

		$(window).on('resize', function(ev) {
			spa_concept_check_adjust_sections();
		});
		spa_concept_check_adjust_sections();
	});

  } catch(e) { console.error(e); }
})();
})();
